/**
 * EventRequest
 */
import React from 'react';
import { connect } from 'react-redux';

// Actions
import { requestLoadEvent } from '../../../../services/events/actions';

interface Props {
    requestLoadEvent: Function;
    eventId: number;
}

export class EventRequest extends React.PureComponent<Props> {
    componentDidMount() {
        const { eventId } = this.props;
        this.props.requestLoadEvent(eventId);
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { requestLoadEvent }
)(EventRequest);
